module.exports = __webpack_public_path__ + "static/media/cloneGoogle.d6d8ce33.png";